import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Snackbar
} from '@material-ui/core';
import i18n from '../../i18n';
import { snackbarDuration } from '../../constants/general';
import '../../assets/stylesheets/Closet.css';

class CartWarnings extends Component {

  constructor(props) {
    super(props);

    this.state = {
      dismiss: false
    }
  }

  closeSnackbar = () => {
    this.setState({ dismiss: true });
  };

  render() {
    const { missingItems } = this.props;
    const { dismiss } = this.state;
    return (
      <Snackbar
        message={i18n.t('closet:removedMissingItems', { nb: missingItems })}
        open={!dismiss && missingItems > 0}
        onClose={this.closeSnackbar}
        autoHideDuration={snackbarDuration}
      />
    )
  }
}

const mapStateToProps = state => ({
  missingItems: state.closetCart.missingItems,
});

CartWarnings.propTypes = {
  missingItems: PropTypes.number.isRequired,
}

export { CartWarnings as CartWarningsNoConnect }
export default connect(mapStateToProps)(CartWarnings);